import { Moment } from 'moment';
import { CertificateDetail } from '../../../common/certificates/models/CertificateDetail';
import { CertificateValue } from '../../../common/certificates/models/valueObjects/CertificateValue';
import { PublicKey } from '../../../common/certificates/models/valueObjects/PublicKey';

export class ReportCertificateDetail extends CertificateDetail {
  constructor(
    id: number,
    publickey: PublicKey,
    isSelfSigned: boolean | null,
    isCa: boolean | null,
    value: CertificateValue,
    encoded: string | null,
    private readonly organizationCertificateId: number | null,
    private readonly fingerprint: string | null,
    private readonly venafiGuid: string | null,
    private readonly reportVenafiLastUpdatedAt: Moment | null
  ) {
    super(id, publickey, isSelfSigned, isCa, value, encoded);
  }

  getOrganizationCertificateId() {
    return this.organizationCertificateId;
  }

  getFingerprint() {
    return this.fingerprint;
  }

  getVenafiGuid() {
    return this.venafiGuid;
  }

  isReportVenafiPopulated() {
    return this.reportVenafiLastUpdatedAt !== null;
  }
}
